import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { notification } from 'antd';
import {
  CartActionType,
  PAYMENT_IN_PROGRESS_KEY,
  PaymentInProgress,
  useCartDispatch,
  useCartState,
} from 'public/context/CartContext';

const CartCrossTabSync = () => {
  const intl = useIntl();
  const dispatch = useCartDispatch();
  const { marketType } = useCartState();
  const [notificationApi, contextHolder] = notification.useNotification();

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== PAYMENT_IN_PROGRESS_KEY || !event.newValue) {
        return;
      }

      let flag: PaymentInProgress | null = null;

      try {
        flag = JSON.parse(event.newValue) as PaymentInProgress;
      } catch (e) {
        return;
      }

      if (!flag || flag.marketType !== (marketType || 'EMARKET')) {
        return;
      }

      dispatch({ type: CartActionType.CLEAR_CART });

      notificationApi.warning({
        message: intl.formatMessage({ id: 'cart.payment_in_progress_message' }),
        description: intl.formatMessage({
          id: 'cart.payment_in_progress_description',
        }),
        showProgress: true,
        pauseOnHover: true,
        duration: 10,
      });
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [marketType, dispatch, intl, notificationApi]);

  return contextHolder;
};

export default CartCrossTabSync;
